import css from '../../../utils/css';

export default css`
  h1,
  h2,
  h3,
  h4,
  p {
    margin: 0;
  }

  button {
    border: none;
    background: none;
    padding: 0;
  }

  h1 {
    font-family: var(--widget-font-family);
    font-size: 26px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }

  h2 {
    font-family: var(--widget-font-family);
    font-size: 22px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }

  h3 {
    font-family: var(--widget-font-family);
    font-size: 18px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.22;
    letter-spacing: normal;
  }

  h4 {
    font-family: var(--widget-font-family);
    font-size: 16px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
  }

  .body-text-mo-2 {
    font-family: var(--widget-font-family);
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    text-align: left;
    color: var(--text-body);
  }

  .body-text---mo {
    font-family: var(--widget-font-family);
    font-size: 16px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
  }

  .subtitle {
    font-family: var(--widget-font-family);
    font-size: 15px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.47;
    letter-spacing: normal;
  }

  .body-text {
    font-family: var(--widget-font-family);
    font-size: 15px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.47;
    letter-spacing: normal;
  }

  .body-text-3 {
    font-family: var(--widget-font-family);
    font-size: 14px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: normal;
  }

  .body-text-2 {
    font-family: var(--widget-font-family);
    font-size: 14px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: normal;
  }

  .sub-text {
    font-family: var(--widget-font-family);
    font-size: 12px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }

  .caption {
    font-family: var(--widget-font-family);
    font-size: 11px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }
`;
